import { render, staticRenderFns } from "./PublicarWpPopup.vue?vue&type=template&id=060a1546&scoped=true&"
import script from "./PublicarWpPopup.vue?vue&type=script&lang=ts&"
export * from "./PublicarWpPopup.vue?vue&type=script&lang=ts&"
import style0 from "./PublicarWpPopup.vue?vue&type=style&index=0&id=060a1546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a1546",
  null
  
)

export default component.exports